import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight ,faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import HomeBanner from "../../../../assets/images/home-banner-1.webp"

function addProducts() {
  return (
    <div>
      <h3>Banner</h3>
      <div className='breadcrum'>
        <p><Link to="/home"><span >About</span></Link> <FontAwesomeIcon
          icon={faAngleRight}
          className="mx-2"
        /><span>Banner</span> <FontAwesomeIcon
            icon={faAngleRight}
            className="mx-2"
          /><span className='active-link'>View</span></p>
      </div>
      <div className='row mb-4 justify-end'>
        <div className='col-md-12 col-sm-12 col-lg-12 d-flex justify-end'>
          <Link to="/about-banner-edit"> <button type="button" className="btn btn-primary fit-content">
          <FontAwesomeIcon
          icon={faEdit}
          className="mx-2"
        /> Edit
          </button></Link>
        </div>
      </div>
      <div className="content-wrapper">
        <div className='row'>
          <div className='col-md-6 col-sm-12 col-lg-6'>
            <div className="mb-3 text-start">
              <label htmlFor="title" className="form-label">
                Title
              </label>
              <input
                type="email"
                className="form-control"
                id="title"
                placeholder="Title"
                required
              />
            </div>
          </div>

          <div className='col-md-6 col-sm-12 col-lg-6'>
            <div className="mb-3 text-start">
              <label htmlFor="buttontext" className="form-label">
                Button Text
              </label>
              <input
                type="text"
                className="form-control"
                id="buttontext"
                placeholder="Button Text"
                required
              />
            </div>
          </div>

          <div className='col-md-6 col-sm-12 col-lg-6'>
            <label htmlFor="image" className="form-label">
              Image
            </label>
            <div className="mb-3 text-start">

              <input
                type="file"
                className="form-control"
                id="image"
                placeholder="Select Image"
                required
              />
              <img src={HomeBanner} alt='HomeBanner' width={50} height={50} className='view-image' />
            </div>
          </div>



        </div>
      </div>
    </div>


  )
}

export default addProducts